import { Component, ChangeDetectionStrategy } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { environment } from '../../../../environments/environment';
import { NotificationsDispatchers, NotificationsService } from '../../../store';
import { PlanerTilGodkendelse } from '@store/models';
import { LegacyService } from 'app/legacy/legacy.service';

@Component({
    selector: 'app-planer-til-godk',
    template: `
        <app-planer-til-godk-ui
            [planerTilGodkendelse]="planerTilGodkendelse$ | async"
            (clickPlan)="clickPlan($event)"
            (dismiss)="dismiss()"
        ><app-planer-til-godk-ui>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PlanerTilGodkendelseContainer {

    planerTilGodkendelse$ = this.notificationsService.getPlanerTilGodk();

    constructor(
        public activeModal: NgbActiveModal,
        private notificationsService: NotificationsService,
        private notificationsDispatchers: NotificationsDispatchers,
        private legacyService: LegacyService
    ) {}

    clickPlan(plan: PlanerTilGodkendelse) {
        this.notificationsDispatchers.navigateToClient(plan.kid);
        const url = `${environment.legacyUrl}/kundeeval/kundeeval.asp?ID=${plan.kid}`;
        const windowParams = `scrollbars,resizable, width=1000,height=800,top=100, left=200`;
        this.legacyService.navigate(url, 'hoponpop', windowParams);
        this.activeModal.close();
    }

    dismiss() {
        this.activeModal.dismiss();
    }

}
